import MyComponentTypes from '../MyComponent/Types'
const MyFormControlHelpers = {
  addTypes(key: string, fnUI: any) {
    MyComponentTypes.addTypesGeneric(MyFormControlHelpers.Types, key, fnUI)
  },
  addTypesFromListLazy(listWithKey: any) {
    MyComponentTypes.addTypesGenericFromListLazy(
      MyFormControlHelpers.Types,
      listWithKey
    )
  },
  addTypesFromListWithoutLazy(listWithKey: any) {
    MyComponentTypes.addTypesGenericFromListWithoutLazy(
      MyFormControlHelpers.Types,
      listWithKey
    )
  },
  addTypesWrap(key: string, fnUI: any) {
    MyComponentTypes.addTypesGeneric(MyFormControlHelpers.TypesWrap, key, fnUI)
  },
  Types: {
    _empty: MyComponentTypes.Types._empty
  },
  TypesWrap: {
    _empty: MyComponentTypes.TypesWrap._empty
  }
}

export default MyFormControlHelpers
